import { createFileRoute } from '@tanstack/react-router';
import { Shield } from 'lucide-react';
import { useState } from 'react';

import { AuditLogDetailModal } from '@/features/compliance/components/audit-log-detail-modal';
import { AuditLogFilters } from '@/features/compliance/components/audit-log-filters';
import { AuditLogStatsCards } from '@/features/compliance/components/audit-log-stats-cards';
import { AuditLogTable } from '@/features/compliance/components/audit-log-table';
import { ComplianceSectionTabs } from '@/features/compliance/components/compliance-section-tabs';
import { ExportCsvButton } from '@/features/compliance/components/export-csv-button';
import type { AuditFilters } from '@/features/compliance/services/compliance.service';

export const Route = createFileRoute('/_app/compliance/auditoria')({
  component: ComplianceAuditoriaPage,
});

function ComplianceAuditoriaPage() {
  const [filters, setFilters] = useState<AuditFilters>({});
  const [selectedId, setSelectedId] = useState<string | null>(null);

  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <span
            className="flex h-9 w-9 items-center justify-center rounded-md"
            style={{ background: 'var(--color-bg-overlay)' }}
            aria-hidden
          >
            <Shield className="h-4 w-4" style={{ color: 'var(--color-fg-muted)' }} />
          </span>
          <div>
            <h1 className="text-2xl font-semibold">Centro de Auditoría</h1>
            <p className="text-sm" style={{ color: 'var(--color-fg-muted)' }}>
              Quién hizo qué, cuándo y desde dónde. Toda la actividad sensible queda registrada.
            </p>
          </div>
        </div>
        <ExportCsvButton filters={filters} />
      </header>

      <ComplianceSectionTabs />

      <AuditLogStatsCards />

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-[260px_1fr]">
        <AuditLogFilters value={filters} onChange={setFilters} />
        <AuditLogTable filters={filters} onSelectEntry={setSelectedId} />
      </div>

      <AuditLogDetailModal
        entryId={selectedId}
        open={selectedId !== null}
        onClose={() => setSelectedId(null)}
      />
    </div>
  );
}
